var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6495_91667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 0C114.6 0 0 114.6 0 256C0 397.4 114.6 512 256 512C397.4 512 512 397.4 512 256C512 114.6 397.4 0 256 0ZM256 464C141.3 464 48 370.69 48 256C48 141.31 141.3 48 256 48C370.7 48 464 141.31 464 256C464 370.69 370.7 464 256 464ZM296 336H280V248C280 234.8 269.3 224 256 224H224C210.8 224 200 234.8 200 248C200 261.2 210.8 272 224 272H232V336H216C202.8 336 192 346.8 192 360C192 373.2 202.8 384 216 384H296C309.25 384 320 373.25 320 360C320 346.75 309.3 336 296 336ZM256 192C273.67 192 288 177.67 288 160C288 142.33 273.67 128 256 128C238.33 128 224 142.3 224 160C224 177.7 238.3 192 256 192Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6495_91667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.03dc0609c6d29ff2e007c85a1d48c008.svg";
export { ForwardRef as ReactComponent };